import * as Sentry from '@sentry/react';

import initIntercom from './intercom';

export default function identify({email, firstName, id, lastName}) {
    /* istanbul ignore next */
    Sentry.configureScope(scope => {
        scope.setUser({email, id});
    });

    /* istanbul ignore if */
    if (
        import.meta.env.HAL_ENVIRONMENT !== 'development' &&
        import.meta.env.HAL_ENVIRONMENT !== 'test'
    ) {
        // load Intercom Messenger
        initIntercom({firstName, id, lastName});
    }

    /* istanbul ignore if */
    if (window.heap) {
        // identify Heap user
        window.heap.identify(id);
        window.heap.addUserProperties({email, id});
    }
}
